// extracted by mini-css-extract-plugin
export var infoRow = "_th-2";
export var labelContainer = "_th-0";
export var rightInfo = "_th-1";